function compare(a, b) {
  return b.perc - a.perc;
}
function orderDescending(response) {
  const inDescendingOrder = response.data.data.generationmix.sort(compare);
  return inDescendingOrder;
}

export { orderDescending };
